import * as React from "react"
import { useTranslation } from "react-i18next"
import Element from "@bappweb/element"
import Page from "@components/globalmodules/page"

const Faq = () => {
  const { t } = useTranslation()

  return (
    <Page>
      <Element type="h1">{t("FAQ")}</Element>
    </Page>
  )
}

export default Faq
